import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { DataGrid } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import Snackbar from "@mui/material/Snackbar";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import SettingsStatus from "../../../pages/General/SettingsStatus";
import {
  fetchSenderAddress,
  destorySenderAddress,
  storeSenderAddress,
  updateSenderAddress,
  resetSenderAddressState,
} from "./addressSenderSlice";
import {
  fetchCountry,
  fetchState,
} from "../../../pages/General/countryStateCitySlice";

import NorowsData from "../../../pages/General/NorowsData";

// Global enterprise styling dictionary configuring standard outlined layout inputs
const enterpriseSenderInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': {
            borderColor: '#CBD5E1',
            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
        },
        '&.Mui-focused': {
            borderColor: '#1976d2', // --- CORPORATE IDENTITY BRAND BLUE ---
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiInputLabel-outlined': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 10px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1976d2',
            fontWeight: 600
        }
    },
    '& input, & .MuiSelect-select': {
        padding: '10px 14px !important',
        fontSize: '13.5px',
        color: '#1E293B',
        fontWeight: 500
    },
    '& .MuiFormHelperText-root': {
        mx: 0.5,
        mt: 0.75,
        fontWeight: 500
    }
};

const enterpriseModalContainerStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '94%', sm: 700, md: 800 },
    maxHeight: '90vh',
    overflowY: 'auto',
    outline: 'none',
    border: 'none',
    boxSizing: 'border-box'
};

const enterpriseDeleteModalStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 420 },
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    border: '1px solid #E2E8F0',
    p: 4,
    outline: 'none',
    overflow: 'hidden'
};

const Modalpopup = ({
  modalVisible,
  setModalVisible,
  formValues,
  setFormValues,
  snackbar,
  buttonStatus
}) => {
  const dispatch = useDispatch();
  const profile = useSelector(state => state.auth.profile); 
  const addresssender = useSelector((state) => state.addresssender);
  const country = useSelector((state) => state.countrystate.country);
  const state = useSelector((state) => state.countrystate.state);
  const filteredCountryData = country.data.filter(({ code }) => code);
  
  const initialSenderAddressValues = {
    sender_name: "",
    sender_address: "",
    sender_address2: "",
    sender_city: "",
    sender_company: "",
    sender_country_code: "",
    sender_email: "",
    sender_phone: "",
    sender_postal_code: "",
    sender_state_code: "",
    status: true,
    default: "",
  };

  const [values, setValues] = useState(
    formValues && Object.keys(formValues).length === 0
      ? initialSenderAddressValues
      : formValues
  );
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (formValues && formValues.sender_country_code) {
      dispatch(fetchState(formValues && formValues.sender_country_code));
    }
  }, [formValues]);

  useEffect(() => {
    if (formValues && Object.keys(formValues).length !== 0) {
        if(buttonStatus){
            setValues({
                ...values,
                sender_name: "",
                sender_address: "",
                sender_address2: "",
                sender_city: "",
                sender_company: "",
                sender_country_code: "",
                sender_email: "",
                sender_phone: "",
                sender_postal_code: "",
                sender_state_code: "",
                status: true,
                default: "",
            })
        }else{
            let tempValues = {
                sender_name: formValues["sender_name"],
                sender_address: formValues["sender_address"],
                sender_address2: formValues["sender_address2"],
                sender_city: formValues["sender_city"],
                sender_company: formValues["sender_company"],
                sender_country_code: formValues["sender_country_code"],
                sender_email: formValues["sender_email"],
                sender_phone: formValues["sender_phone"],
                sender_postal_code: formValues["sender_postal_code"],
                sender_state_code: formValues["sender_state_code"],
                status: formValues["status"],
                default: formValues["default"],
            };
            setValues(tempValues);
            setErrors({});
        }
    }else{
        setValues({
            ...values,
            sender_name: "",
            sender_address: "",
            sender_address2: "",
            sender_city: "",
            sender_company: "",
            sender_country_code: "",
            sender_email: "",
            sender_phone: "",
            sender_postal_code: "",
            sender_state_code: "",
            status: true,
            default: "",
        })
    }
  }, [formValues]);

  const onModalClose = () => {
    setModalVisible(false);
  };

  const validator = (fieldValues) => {
    let temp = { ...errors };
    if ("sender_name" in fieldValues)
      temp.sender_name = fieldValues.sender_name
        ? ""
        : "This field is required.";
    if (
      fieldValues &&
      fieldValues.sender_name &&
      fieldValues.sender_name.length < 3
    )
      temp.sender_name = "Sender Name required minimum 3 characters";
    if ("sender_address" in fieldValues)
      temp.sender_address = fieldValues.sender_address
        ? ""
        : "This field is required.";
    if ("sender_city" in fieldValues)
      temp.sender_city = fieldValues.sender_city
        ? ""
        : "This field is required.";
    if ("sender_company" in fieldValues)
      temp.sender_company = fieldValues.sender_company
        ? ""
        : "This field is required.";
    if ("sender_country_code" in fieldValues)
      temp.sender_country_code = fieldValues.sender_country_code
        ? ""
        : "This field is required.";
    if ("sender_email" in fieldValues)
      temp.sender_email = fieldValues.sender_email
        ? ""
        : "This field is required.";
    if ("sender_phone" in fieldValues)
      temp.sender_phone = fieldValues.sender_phone
        ? ""
        : "This field is required.";
    if (
      fieldValues &&
      fieldValues.sender_phone &&
      fieldValues.sender_phone.match(/[^0-9+().,\-]/i)
    ) {
      temp.sender_phone = "phone number must be valid";
    }
    if ("sender_postal_code" in fieldValues)
      temp.sender_postal_code = fieldValues.sender_postal_code
        ? ""
        : "This field is required.";
    if (
      (fieldValues &&
        fieldValues.sender_postal_code &&
        fieldValues.sender_postal_code.length < 3) ||
      (fieldValues &&
        fieldValues.sender_postal_code &&
        fieldValues.sender_postal_code === null)
    )
      temp.sender_postal_code =
        "Sender Postalcode required minimum 3 characters";
    if (
      fieldValues &&
      fieldValues.sender_postal_code &&
      fieldValues.sender_postal_code.match(/[^0-9a-z-\s]/i)
    ) {
      temp.sender_postal_code = "Postal code only accepts alpha numeric";
    }
    if ("sender_state_code" in fieldValues)
      temp.sender_state_code = fieldValues.sender_state_code
        ? ""
        : "This field is required.";

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x == "");
    }
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    if(e.target.name === 'sender_postal_code'){
      setValues({
        ...values,
        [name]: value.replace(/\s/g, ''),
      });
   }else{
      setValues({
        ...values,
        [name]: value,
      });
   }
    validator({ [name]: value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: e.target.checked,
    });
    validator({ [name]: value });
  };

  const onSelectCountryChange = (countryCode) => {
    setValues({
      ...values,
      sender_country_code: countryCode,
    });
    setErrors({ sender_country_code: "" });
    dispatch(fetchState(countryCode));
  };

  const getSelectedCountry = (country_code) => {
    let filteredValue = { code: "", name: "" };
    filteredCountryData.map((key) => {
      if (key.code == country_code) {
        filteredValue = key;
      }
    });
     return filteredValue;
  };

  const onSelectStateChange = (currentstate) => {
    setValues({
      ...values,
      sender_state_code: currentstate,
    });
    setErrors({ sender_state_code: "" });
  };

  const getSelectedState = (currentstate) => {
    let filteredStateValue = { code: "", name: "" };
    let tempState = "";
    state &&
      state.data &&
      state.data.map((key) => {
        if (key.code == currentstate && tempState == "") {
          filteredStateValue = key;
          tempState = "success";
        }
      });
    return filteredStateValue;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validator(values);
    if (isValid) {
      if ("_id" in formValues) {
        dispatch(updateSenderAddress(profile && profile.id,formValues._id, values));
        snackbar(true);
      } else {
        dispatch(storeSenderAddress(profile && profile.id,values));
        snackbar(true);
      }
    }
  };
  
  useEffect(() => {
    if (addresssender && addresssender.message) {
      if (addresssender && addresssender.messageType == "success") {
        setValues(initialSenderAddressValues);
        setErrors({});
      }
    }
  }, [addresssender]);

  return (
    <Modal
      open={modalVisible}
      onClose={onModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
    >
      <Box sx={enterpriseModalContainerStyles}>
        <Card 
            className="sc--cardhead--details"
            sx={{ 
                backgroundColor: '#FFFFFF',
                borderRadius: '16px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                border: '1px solid #E2E8F0',
                overflow: 'hidden'
            }}
        >
          <CardHeader 
              title={
                  <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                      Sender Address Settings
                  </Typography>
              }
              action={
                  <IconButton 
                      aria-label="close" 
                      onClick={onModalClose}
                      sx={{ color: '#64748B', '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' } }}
                  >
                      <CloseIcon sx={{ fontSize: '20px' }} />
                  </IconButton>
              }
              sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
          />
          <Divider sx={{ borderColor: '#E2E8F0' }} />
          <CardContent sx={{ p: 4, boxSizing: 'border-box' }}>
            <Grid container spacing={3}>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Name*"
                  name="sender_name"
                  size="small"
                  defaultValue={formValues && formValues.sender_name}
                  onChange={onInputChange}
                  error={!!errors.sender_name}
                  helperText={errors.sender_name}
                  inputProps={{ maxLength: 40 }}
                  variant="outlined"
                  sx={enterpriseSenderInputStyles}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Company*"
                  name="sender_company"
                  size="small"
                  defaultValue={formValues && formValues.sender_company}
                  onChange={onInputChange}
                  error={!!errors.sender_company}
                  helperText={errors.sender_company}
                  inputProps={{ maxLength: 40 }}
                  variant="outlined"
                  sx={enterpriseSenderInputStyles}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Phone*"
                  name="sender_phone"
                  size="small"
                  defaultValue={formValues && formValues.sender_phone}
                  onChange={onInputChange}
                  error={!!errors.sender_phone}
                  inputProps={{ maxLength: 13 }}
                  helperText={errors.sender_phone}
                  variant="outlined"
                  sx={enterpriseSenderInputStyles}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email*"
                  name="sender_email"
                  size="small"
                  defaultValue={formValues && formValues.sender_email}
                  onChange={onInputChange}
                  error={!!errors.sender_email}
                  inputProps={{ maxLength: 60 }}
                  helperText={errors.sender_email}
                  variant="outlined"
                  sx={enterpriseSenderInputStyles}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Address1*"
                  name="sender_address"
                  size="small"
                  defaultValue={formValues && formValues.sender_address}
                  onChange={onInputChange}
                  error={!!errors.sender_address}
                  inputProps={{ maxLength: 35 }}
                  helperText={errors.sender_address}
                  variant="outlined"
                  sx={enterpriseSenderInputStyles}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Address2"
                  name="sender_address2"
                  size="small"
                  defaultValue={formValues && formValues.sender_address2}
                  onChange={onInputChange}
                  error={!!errors.sender_address2}
                  inputProps={{ maxLength: 35 }}
                  helperText={errors.sender_address2}
                  variant="outlined"
                  sx={enterpriseSenderInputStyles}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Postal Code*"
                  name="sender_postal_code"
                  size="small"
                  defaultValue={formValues && formValues.sender_postal_code}
                  onChange={onInputChange}
                  inputProps={{ maxLength: 10 }}
                  error={!!errors.sender_postal_code}
                  helperText={errors.sender_postal_code}
                  variant="outlined"
                  sx={enterpriseSenderInputStyles}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="City*"
                  name="sender_city"
                  size="small"
                  defaultValue={formValues && formValues.sender_city}
                  onChange={onInputChange}
                  error={!!errors.sender_city}
                  inputProps={{ maxLength: 30 }}
                  helperText={errors.sender_city}
                  variant="outlined"
                  sx={enterpriseSenderInputStyles}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  className="help-text-error"
                  disablePortal
                  size="small"
                  name="sender_country_code"
                  id="country-select-demo"
                  options={filteredCountryData}
                  autoHighlight
                  loading={country && country.loading}
                  getOptionLabel={(option) => option.name || ""}
                  value={getSelectedCountry(values && values.sender_country_code)}
                  sx={{
                      width: '100%',
                      '& .MuiAutocomplete-inputRoot': enterpriseSenderInputStyles['& .MuiOutlinedInput-root'],
                      '& .MuiInputLabel-root': enterpriseSenderInputStyles['& .MuiInputLabel-outlined'],
                      '& input': enterpriseSenderInputStyles['& input']
                  }}
                  renderOption={(props, option) => (
                    <MenuItem {...props} value={option.code} key={option.code} sx={{ fontSize: '13.5px', fontWeight: 500 }}>
                      {option.icon} {option.name}
                    </MenuItem>
                  )}
                  onChange={(event, value) => {
                    if (value !== null) {
                      onSelectCountryChange(value.code);
                      setErrors({ sender_country_code: "" });
                    } else {
                      onSelectCountryChange("");
                      setErrors({
                        sender_country_code: "This field is required",
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Country*"
                      variant="outlined"
                      error={!!errors.sender_country_code}
                      helperText={errors.sender_country_code}
                      sx={{ '& .MuiFormHelperText-root': enterpriseSenderInputStyles['& .MuiFormHelperText-root'] }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  className="help-text-error"
                  disablePortal
                  size="small"
                  name="sender_state_code"
                  id="state-select-demo"
                  options={state && state.data || []}
                  autoHighlight
                  loading={
                    (state && state.loading) || (country && country.loading)
                  }
                  getOptionLabel={(option) => option.name || ""}
                  value={getSelectedState(values && values.sender_state_code)}
                  sx={{
                      width: '100%',
                      '& .MuiAutocomplete-inputRoot': enterpriseSenderInputStyles['& .MuiOutlinedInput-root'],
                      '& .MuiInputLabel-root': enterpriseSenderInputStyles['& .MuiInputLabel-outlined'],
                      '& input': enterpriseSenderInputStyles['& input']
                  }}
                  renderOption={(props, option) => (
                    <MenuItem {...props} value={option.code} key={option.code} sx={{ fontSize: '13.5px', fontWeight: 500 }}>
                      {option.name}
                    </MenuItem>
                  )}
                  onChange={(event, value) => {
                    if (value !== null) {
                      onSelectStateChange(value.code);
                    } else {
                      onSelectStateChange("");
                      setErrors({ sender_state_code: "This field is required" });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="State*"
                      variant="outlined"
                      error={!!errors.sender_state_code}
                      helperText={errors.sender_state_code}
                      sx={{ '& .MuiFormHelperText-root': enterpriseSenderInputStyles['& .MuiFormHelperText-root'] }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ p: 2, backgroundColor: '#F8FAFC', borderRadius: '12px', border: '1px solid #E2E8F0' }}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          defaultChecked={formValues && formValues.default}
                          name="default"
                          onChange={handleChange}
                          sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#1976d2' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#1976d2' } }}
                        />
                      }
                      label={<Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: '#334155' }}>Default Address Configuration</Typography>}
                    />
                  </FormGroup>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, pt: 2, borderTop: '1px solid #E2E8F0', mt: 1 }}>
                  <Button 
                    variant="outlined" 
                    onClick={onModalClose}
                    sx={{
                        textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 3,
                        borderColor: '#E2E8F0', color: '#475569', '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                    }}
                  >
                    Cancel
                  </Button>
                  <Button 
                    variant="contained" 
                    onClick={handleSubmit}
                    sx={{
                        textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 4, boxShadow: 'none',
                        backgroundColor: '#1976d2', color: '#FFFFFF', '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Grid>

            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

const AddressSenderPage = () => {
  const dispatch = useDispatch();
  const addresssender = useSelector((state) => state.addresssender);
  const profile = useSelector(state => state.auth.profile); 

  const [alert, setAlert] = useState(false);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [deleteModalopen, setDeleteModalopen] = React.useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [deleteid, setDeleteId] = React.useState("");
  const [clickAddbuttonStatus, setClickAddbuttonStatus] = React.useState(false);

  useEffect(() => {
    dispatch(fetchSenderAddress());
    dispatch(fetchCountry());
  }, [dispatch]);

  useEffect(() => {
    if (addresssender && addresssender.message) {
      setAlert(true);
      setSnackOpen(true);
      if (addresssender && addresssender.messageType == "success") {
        setModalVisible(false);
        setSelectedItem({});
      }
    }
  }, [addresssender]);

  const handleClick = (id) => {
    setDeleteId(id);
    setDeleteModalopen(true);
  };

  const deleteModalClose = () => {
    setDeleteModalopen(false);
  };

  const deleteaddress = (id) => {
    dispatch(destorySenderAddress(profile && profile.id,id));
    setAlert(true);
    setSnackOpen(true);
    setDeleteModalopen(false);
  };
  const snackhandleClose = () => {
    setAlert(false);
    setSnackOpen(false);
    dispatch(resetSenderAddressState());
  };

  const snackbar = (value) => {
    setSnackOpen(value);
  };

  const columns = [
    { field: "_id", headerName: "Address Id", flex: 1, minWidth: 110 },
    { field: "sender_name", headerName: "Name", flex: 1, minWidth: 120  },
    { field: "sender_company", headerName: "Company Name", flex: 1, minWidth: 130  },
    { field: "sender_phone", headerName: "Phone Number", flex: 1, minWidth: 120  },
    { field: "sender_email", headerName: "Email", flex: 1, minWidth: 150  },
    { field: "sender_address", headerName: "Address", flex: 1.2, minWidth: 160  },
    { field: "sender_city", headerName: "City", flex: 1, minWidth: 110  },
    { field: "sender_state_code", headerName: "Province", flex: 0.8, minWidth: 100  },
    { field: "sender_country_code", headerName: "Country", flex: 0.8, minWidth: 100  },
    { field: "sender_postal_code", headerName: "Postal", flex: 0.8, minWidth: 100  },
    {
      field: "status",
      headerName: "Status",
      flex: 0.8,
      minWidth: 100,
      renderCell: (params) => {
        return <SettingsStatus settingsStatus={params.row.status} />;
      },
    },
    {
      field: "default",
      headerName: "Default",
      flex: 0.8,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            {params.row.default == true ? (
              <Chip
                label="Yes"
                size="small"
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  height: "22px",
                  borderRadius: "6px",
                  backgroundColor: '#E8F5E9',
                  color: '#2E7D32',
                  border: '1px solid #C8E6C9'
                }}
              />
            ) : (
              <Chip
                label="No"
                size="small"
                sx={{
                  fontSize: "11px",
                  fontWeight: 600,
                  height: "22px",
                  borderRadius: "6px",
                  backgroundColor: '#F5F5F5',
                  color: '#616161',
                  border: '1px solid #E0E0E0'
                }}
              />
            )}
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
            <Tooltip title="Edit Address" placement="top">
              <IconButton
                onClick={() => {
                  setSelectedItem(params.row);
                  setModalVisible(true);
                  setClickAddbuttonStatus(false);
                }}
                sx={{ 
                    color: '#64748B', padding: '6px', borderRadius: '8px', border: '1px solid #E2E8F0', backgroundColor: '#FFFFFF',
                    '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1', color: '#1E293B' }
                }}
              >
                <EditIcon sx={{ fontSize: '16px' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete Address" placement="top">
              <IconButton
                onClick={(e) => {
                  handleClick(params.row._id);
                }}
                sx={{ 
                    color: '#EF4444', padding: '6px', borderRadius: '8px', border: '1px solid #FEE2E2', backgroundColor: '#FFFFFF',
                    '&:hover': { backgroundColor: '#FEF2F2', borderColor: '#FCA5A5' }
                }}
              >
                <DeleteOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  return (
    <Box className="sc--settings--card" sx={{ width: '100%', boxSizing: 'border-box', p: 2.5 }}>
      
      {/* Modal: Irreversible Delete Confirmation Intercept safe house */}
      <Modal
        open={deleteModalopen}
        onClose={deleteModalClose}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
        closeAfterTransition
      >
        <Box sx={enterpriseDeleteModalStyles}>
          <Typography id="delete-modal-title" variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', mb: 1.5, textAlign: 'center', fontSize: '16px' }}>
            Delete Sender Address
          </Typography>
          <Typography id="delete-modal-description" variant="body2" sx={{ color: '#475569', fontWeight: 500, lineHeight: 1.6, mb: 4, textAlign: 'center' }}>
            Are you sure want to delete this sender address?<br />This optimization routing directory modification is permanent.
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, width: '100%' }}>
            <Button 
                variant="outlined" 
                onClick={deleteModalClose}
                sx={{
                    textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 3.5,
                    borderColor: '#E2E8F0', color: '#475569', '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                }}
            >
                No, Keep
            </Button>
            <Button 
                variant="contained" 
                onClick={(event) => deleteaddress(deleteid)}
                sx={{
                    textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 4.5, boxShadow: 'none',
                    backgroundColor: '#EF4444', color: '#FFFFFF', '&:hover': { backgroundColor: '#DC2626', boxShadow: 'none' }
                }}
            >
                Yes, Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modalpopup
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        formValues={clickAddbuttonStatus==false ? selectedItem: {}}
        setFormValues={setSelectedItem}
        snackbar={snackbar}
        buttonStatus={clickAddbuttonStatus}
      />

      {alert && addresssender && addresssender.loading === false && (
        <Snackbar
          open={snackOpen}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          autoHideDuration={6000}
          onClose={snackhandleClose}
          sx={{ mt: 2 }}
        >
          <Alert
            severity={
              addresssender && addresssender.hasErrors === true
                ? "error"
                : "success"
            }
            onClose={snackhandleClose}
            variant="filled"
            sx={{ width: '100%', borderRadius: '12px', fontWeight: 600, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.05)', fontSize: '13px', alignItems: 'center' }}
          >
            <span>{addresssender && addresssender.message}</span>
          </Alert>
        </Snackbar>
      )}

      {/* Core Card Document Presentation Surface Workspace Panel */}
      <Card
        sx={{ 
            width: '100%', 
            backgroundColor: '#FFFFFF',
            border: '1px solid #E2E8F0',
            borderRadius: '16px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
            overflow: 'hidden'
        }} 
        className="sc--cardhead--details"
      >
        <Box 
            sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2.5, borderBottom: '1px solid #E2E8F0', flexWrap: 'wrap', gap: 2
            }}
        >
          <Typography variant="h5" component="h1" sx={{ fontWeight: 800, color: '#0F172A', letterSpacing: '-0.5px', margin: 0, fontSize: '1.25rem' }}>
              Sender Address Directory
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              setModalVisible(true);
              setClickAddbuttonStatus(true);
            }}
            sx={{
                textTransform: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13.5px', height: '38px', px: 3, boxShadow: 'none',
                backgroundColor: '#1976d2', color: '#FFFFFF', '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
            }}
          >
            Add Address
          </Button>
        </Box>
        <Divider sx={{ display: 'none' }} />
        <CardContent sx={{ p: 0 }}>
          <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
            <DataGrid
              sx={{
                  border: 'none',
                  backgroundColor: '#FFFFFF',
                  // FIXED: Pass a strict height calculation token so the inner scroller layer doesn't compress to 0px
                  height: (!addresssender || !addresssender.data || addresssender.data.length === 0) ? 380 : 'auto',
                  // FIXED: MUI DataGrid custom token to force the container context area to stretch for overlays
                  '--DataGrid-overlayHeight': '300px',
                  
                  '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                  '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                  '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                  '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                  '& .MuiDataGrid-cell': { borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                  '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
              }}
              getRowId={(row) => row._id}
              disableRowSelectionOnClick={true}
              rows={addresssender && addresssender.data || []}
              columns={columns}
              slots={{
                loadingOverlay: LinearProgress,
                noRowsOverlay: NorowsData,
              }}
              hideFooter={true}
              loading={addresssender && addresssender.loading}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AddressSenderPage;